// import log from 'salvo-lite/log'
import HcSticky from 'hc-sticky'
import getNodeDimensions from 'get-node-dimensions'

class StickyElem {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._sticky = null
        this._header = document.querySelector('[data-header]')
        this._options = Object.assign({
            top: 0,
            bottom: 0,
            onStart: () => {
                this._elem.classList.remove('just-become-unsticky')
            },
            onStop: () => {
                this._elem.classList.add('just-become-unsticky')
                setTimeout(() => {
                    this._elem.classList.remove('just-become-unsticky')
                }, 500)
            }
        }, JSON.parse(this._elem.dataset.sticky || '{}'))
        // log.debug(this.constructor.name, 'Constructed', this)

        if (!this._options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    init () {
    // log.debug(this.constructor.name, 'Initiating')
        this._sticky = new HcSticky(this._elem, this._options)

        document.addEventListener('update-sticky', () => {
            this._sticky.update()
        })

        document.addEventListener('header-visible', () => {
            if (this._options.ignoreHeader) {
                return false
            }
            this._sticky.update({
                top: getNodeDimensions(this._header).height
            })
        })

        document.addEventListener('header-hide', () => {
            this._sticky.update({
                top: 0
            })
        })

    // log.debug(this.constructor.name, 'Initiated')
    }
}

export default StickyElem



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StickyElem.js